// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._nd5l8niw{grid-area:comment-area}._1q51v77o{padding-block-start:var(--ds-space-025,2px)}\n._1ul9idpf{min-width:0}\n._slp31hna{word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
